// src/config/googleMaps.js
export const GOOGLE_MAPS_LOADER_ID = "google-maps-main";

export const GOOGLE_MAPS_API_KEY =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";